import { useAppDispatch, useAppSelector } from "config/store";
import { adminActions } from "config/store/modules/admin.ts";
import { useNavigate } from "react-router-dom";
import AdminConnectedContainer from "components/container/AdminConnectedContainer.tsx";
import { useTranslation } from "react-i18next";
import { tryAsyncFunc } from "globals/functions/async.ts";
import ajax from "config/ajax.ts";
import LoadingContainer from "components/container/LoadingContainer.tsx";
import { Form, Formik } from "formik";
import Button from "components/atom/button/Button.tsx";
import { UserFormValuesType } from "utils/form.ts";
import { USER_PLAN_TYPES, USER_TYPES } from "globals/constants.ts";
import AdminUserForm from "components/layouts/form/AdminUserForm.tsx";
import dayjs from "dayjs";

function AdminCreateUserPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const currentLang = useAppSelector(state => state.global.currentLang);

  const values: UserFormValuesType = {
    name: "",
    email: "",
    unverifiedEmail: "",
    preferredLang: currentLang,
    acceptCommunications: false,
    acceptTerms: true,

    type: USER_TYPES.EVENT_MANAGER,

    address: "",
    city: "",
    zipcode: "",
    state: "QC",
    country: "CA",

    billingAddress: "",
    billingCity: "",
    billingZipcode: "",
    billingState: "QC",
    billingCountry: "CA",

    trialEndedAt: dayjs().add(1, "months").format("YYYY-MM-DD"),

    website: "",
    phoneNumber: "",
    planType: USER_PLAN_TYPES.TRIAL,

    sameAddress: true
  };


  return (
    <AdminConnectedContainer title={t("user.create")}>
      <div className="w-full">
        <Formik
          initialValues={values}
          validateOnChange={false}
          validateOnBlur={false}
          validate={values => {
            const errors: Partial<{ [K in keyof UserFormValuesType]: string }> = {};//same keys as type but with string value
            if (!values.name) {
              errors.name = t("forms.errors.requiredName");
            }
            if (!values.email) {
              errors.email = t("forms.errors.requiredEmail");
            }
            return errors;
          }}
          onSubmit={async (values, { setSubmitting, setStatus, setFieldError }) => {
            setSubmitting(true);
            setStatus(null);

            const [res, err] = await tryAsyncFunc(ajax.post(`/connected/admin/users`, values));
            setSubmitting(false);

            if (err) {
              const errData = err.response.data || {};
              const errors = errData.errors || {};

              if (errors.global) {
                setStatus(errors.global);
                delete errors.global;
              }

              Object.keys(errors).forEach(errKey => {
                setFieldError(errKey, errors[errKey]);
              });
              return;
            }

            await dispatch(adminActions.createdUser(res.data.user));
            navigate(`/profile/admin/users/${res.data.user.id}`);
          }}
        >
          {({ isSubmitting, status }) => (
            <LoadingContainer isLoading={isSubmitting} keepChildren>
              <Form>
                <AdminUserForm />

                {status && (
                  <p className="error block">{status}</p>
                )}
                <div className="mt-4 flex w-full flex-col items-center justify-center gap-4">
                  <Button className="w-full" type="submit" disabled={isSubmitting}>
                    {t("save")}
                  </Button>
                </div>
              </Form>
            </LoadingContainer>
          )}
        </Formik>

      </div>
    </AdminConnectedContainer>
  );
}

export default AdminCreateUserPage;
